module.exports = __webpack_public_path__ + "img/pic4_bg_hover.31e3749.png";